(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sia-product-bundles"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sia-product-bundles'))customElements.define('sia-product-bundles',class extends HTMLElement{
 connectedCallback(){
  this.form=this.closest('form');this.select=this.querySelector('[data-bundle]');this.extra=this.querySelector('[data-extra]');this.error=this.querySelector('[data-bundle-error]');this.standalone=this.dataset.standalone==='true';
  this.select.addEventListener('change',()=>{if(this.standalone)this.extra.value=this.select.value==='0'?'1':'0';this.update()});this.extra.addEventListener('input',()=>this.update());
  this.form.addEventListener('submit',e=>this.submit(e),true);this.update();
 }
 update(){let option=this.select.selectedOptions[0],qty=Number(this.extra.value);this.extra.setCustomValidity(this.standalone&&option.value==='0'&&qty<1?this.dataset.error:'');let total=(this.standalone?0:Number(this.dataset.base))+Number(option.dataset.price)+Math.max(0,qty||0)*Number(this.dataset.singlePrice);this.querySelector('[data-total]').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(total/100);}
 async submit(event){event.preventDefault();event.stopImmediatePropagation();if(this.busy||!this.form.reportValidity())return;this.busy=true;let button=this.form.querySelector('[type=submit]');button.disabled=true;this.error.textContent='';
 try{let data=new FormData(this.form),props={};for(let [key,value]of data)if(key.startsWith('properties['))props[key.slice(11,-1)]=value;
 let option=this.select.selectedOptions[0],qty=Number(this.extra.value),items=[];props['Product count']=String(Number(option.dataset.count)+qty);
 if(!this.standalone)items.push({id:Number(data.get('id')),quantity:1,properties:props});
 let addonProps={...props,'Service context':this.standalone?'Standalone product checking and cleanup':'Website design add-on','Scope':'Purchased product count: supplied images, descriptions and on-page SEO. No ranking guarantee.'};
 if(option.value!=='0')items.push({id:Number(option.value),quantity:1,properties:addonProps});
 if(qty>0)items.push({id:Number(this.dataset.singleId),quantity:qty,properties:addonProps});
 let response=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error();window.location.assign(this.dataset.cart);
 }catch(error){this.error.textContent=this.dataset.error;button.disabled=false;this.busy=false;}
 }
});
  } catch(e) { console.error(e); }
})();

})();
